export default __webpack_public_path__ + "static/Camino-logo-200f88278dd20cad74fc21cf56d7441d.jpeg";